import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import './styles.css';

export interface BaseLayoutProps {
  children: React.ReactNode;
  navigation?: React.ReactNode;
  fluid?: boolean;
  className?: string;
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  navigation,
  fluid = false,
  className = ''
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <>
      <div
        className={`
          base-layout
          ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}
          ${fluid ? 'layout-fluid' : ''}
          ${className}
        `.trim()}
      >
        <header className="layout-header">
          <div className="content-container header-inner">
            <div className="header-left">
              <button
                className="sidebar-toggle"
                onClick={toggleSidebar}
                aria-label={isSidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                aria-expanded={isSidebarOpen}
              >
                {isSidebarOpen ? <FiX /> : <FiMenu />}
              </button>
              <h1 className="header-title desktop-title">STS AI Eval</h1>
            </div>

            <div className="header-center mobile-title">
              <h1 className="header-title">STS AI Eval</h1>
            </div>

            <div className="header-right">
              {isAuthenticated && (
                <button className="logout-button" onClick={handleLogout} title="Logout">
                  <FiLogOut />
                  <span>Logout</span>
                </button>
              )}
            </div>
          </div>
        </header>

        <div className="layout-body">
          <div className="content-container main-inner">
            <aside className="layout-sidebar">
              {navigation}
            </aside>
            <main className="layout-main">
              {children}
            </main>
          </div>
        </div>
      </div>
      <div 
        className={`sidebar-overlay ${isSidebarOpen ? 'is-active' : ''}`}
        onClick={closeSidebar}
        role="button"
        tabIndex={0}
        aria-label="Close sidebar"
      ></div>
    </>
  );
};

export default BaseLayout; 